import React from 'react';
import loadable from 'utils/loadable';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import * as PropTypes from 'prop-types';

function ComponentLoadable({ reservationId, fallback })
{
    const LazyLoad = loadable(() => import('.'), { fallback: fallback ?? <LoadingSpinner loading /> });
    return (
        <LazyLoad
            reservationId={reservationId}
        />
    );
}

ComponentLoadable.propTypes = {
    fallback: PropTypes.node,
    reservationId: PropTypes.number.isRequired,
};

export default ComponentLoadable;
